import { getUrlParam, getLocation } from '@/utils';
import { USER_TYPE_ID_MAP } from './constants';

export async function getLocationObj(isHideLoading = false) {
  let locationObj = {};
  const cityId = getUrlParam('location_city_id') || getUrlParam('city_id');
  locationObj.cityId = cityId && cityId != 0 ? cityId : null;

  console.log('act_tpl_hub project fetch location from cityId', cityId);
  if (!locationObj.cityId) {
    const isSkipWechat = getUrlParam('bl') === '8'; // 小拉暂不走微信定位
    locationObj = await getLocation(isHideLoading, isSkipWechat);
  }
  return locationObj;
}

/**
 * 是否企业app
 * @param {} bl 业务线
 * @returns
 */
export function isEnterprise(bl) {
  return Number(bl) === 6;
}

/**
 * 解析出 login 接口用的 userType
 * @param {*} userType url 的 u 参数值
 * @param {*} businessLine 业务线 code
 * @returns
 */
export function parseUserTypeForLogin(userType, businessLine) {
  if (Number(businessLine) === 6) {
    return 'company';
  }
  return USER_TYPE_ID_MAP[userType];
}
